import React from 'react';
import LatestNewsAndInsights from './LatestNewsAndInsights';

const LatestNewsAndInsightsWithProps = (props: any) => {
  return (
    <LatestNewsAndInsights
      sectionTitle={props.sectionTitle}
      sectionDescription={props.sectionDescription}
      sectionCtaLabel={props.sectionCtaLabel}
      sectionCtaLink={props.sectionCtaLink}
    />
  );
};

export default LatestNewsAndInsightsWithProps;
